window.addEventListener('DOMContentLoaded',()=>{
    observeMenuToggle('.shopify-section-header-sticky','menu-open','mobile-menu-visible');
    observeMenuToggle('cart-drawer', 'animate','cart-open');

    // Select the element to observe
})



function observeMenuToggle(selector, containsClass,bodyClass) {
    const elements = document.querySelectorAll(selector);
  
    elements.forEach(element => {
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'class'
          ) {
            if (element.classList.contains(containsClass)) {
              document.body.classList.add(bodyClass);
            } else {
              document.body.classList.remove(bodyClass);
            }
          }
        });
      });
  
      observer.observe(element, {
        attributes: true,
        attributeFilter: ['class']
      });
    });
  }

  
  